import { ActionReducer, createReducer, on } from '@ngrx/store';
import { initialState, UserState } from './user.state';
import {
  getCurrentUser,
  getCurrentUserFailure,
  getCurrentUserSuccess,
  setCurrentUser,
  setOrderHistoryViewType,
  setOrderHistoryViewTypeLocal,
  setRegionalCulture,
  setUserLanguageLocal,
  setUserLanguageSuccess,
  updateBalanceInfo,
  updateBalanceInfoFailure,
  updateBalanceInfoPending,
  updateBalanceInfoSuccess,
} from './user.actions';

export const userReducer: ActionReducer<UserState> = createReducer(
  initialState,
  on(getCurrentUser, (state: UserState) => {
    return { ...state, isUserLoading: true };
  }),

  on(getCurrentUserSuccess, (state: UserState, { user }) => {
    return { ...state, user, isUserLoading: false };
  }),

  on(getCurrentUserFailure, (state: UserState) => {
    return { ...state, isUserLoading: false };
  }),

  on(updateBalanceInfo, (state: UserState) => ({ ...state, isBalanceInfoLoading: true })),

  on(updateBalanceInfoPending, (state: UserState, { contractId }) => ({
    ...state,
    balanceInfo: contractId && contractId === state.balanceInfoContractId ? state.balanceInfo : null,
    balanceInfoContractId: contractId,
    isBalanceInfoLoading: true,
  })),

  on(updateBalanceInfoSuccess, (state: UserState, { balanceInfo }) => {
    return { ...state, balanceInfo, isBalanceInfoLoading: false };
  }),

  on(updateBalanceInfoFailure, (state: UserState) => {
    return { ...state, isBalanceInfoLoading: false };
  }),

  on(setCurrentUser, (state: UserState, { user }) => {
    return { ...state, user, isUserLoading: false };
  }),

  on(setUserLanguageSuccess, (state: UserState, { language }) => {
    return { ...state, language };
  }),

  on(setUserLanguageLocal, (state: UserState, { language }) => {
    return { ...state, language: { ...state.language, ...language } };
  }),

  on(setRegionalCulture, (state: UserState, { regionalInfo }) => {
    return { ...state, regionalInfo };
  }),

  on(setOrderHistoryViewType, setOrderHistoryViewTypeLocal, (state: UserState, { orderHistoryViewType }) => {
    return { ...state, orderHistoryViewType };
  }),
);
